import * as React from 'react'
import { Switch as AntSwitch } from 'antd'
import type { SwitchProps as AntSwitchProps } from 'antd'

export interface SwitchProps extends Omit<AntSwitchProps, 'onChange'> {
  onCheckedChange?: (checked: boolean) => void
  onChange?: (checked: boolean) => void
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ onCheckedChange, onChange, disabled, className, ...props }, ref) => (
    <span className={`inline-flex ${disabled ? 'cursor-not-allowed' : ''}`}>
      <AntSwitch
        ref={ref}
        onChange={(checked) => {
          if (disabled) return
          if (onCheckedChange) onCheckedChange(checked)
          else if (onChange) onChange(checked)
        }}
        className={`${className || ''} ${disabled ? 'pointer-events-none' : ''}`.trim()}
        {...props}
      />
    </span>
  ),
)
Switch.displayName = 'Switch'

export { Switch }